// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hanatour-header[data-v-431c5e6c]{height:100%;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
